import SearchCard from "./SearchCard";
import {
  ChevronRightRounded as ExpandIcon,
  ExpandMoreRounded as CollapseIcon,
} from "@mui/icons-material";
import {
  Card,
  CardContent,
  Collapse,
  IconButton,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import { useState } from "react";

const GroupedSearchCard = ({
  group,
  searchConfig,
  configLoading,
  filterClicked,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const latestSubmission = group.submissions[0];

  const getDateRange = () => {
    const dates = group.submissions
      .map((s) => new Date(s.effectiveDate))
      .sort((a, b) => a - b);
    const earliest = dates[0];
    const latest = dates[dates.length - 1];

    if (earliest.getFullYear() === latest.getFullYear()) {
      return latest.getFullYear().toString();
    }
    return `${earliest.getFullYear()}-${latest.getFullYear()}`;
  };

  if (group.submissions.length === 1) {
    return (
      <SearchCard
        submission={latestSubmission}
        searchConfig={searchConfig}
        configLoading={configLoading}
        filterClicked={filterClicked}
        {...props}
      />
    );
  }

  return (
    <Card
      elevation={0}
      sx={{
        marginBottom: "8px",
        cursor: "pointer",
      }}
    >
      <CardContent sx={{ padding: "0 !important" }}>
        <SearchCard
          submission={latestSubmission}
          searchConfig={searchConfig}
          configLoading={configLoading}
          filterClicked={filterClicked}
          sx={{
            marginBottom: 0,
            "& .MuiCard-root": {
              marginBottom: 0,
            },
          }}
        />

        {
          <Box
            onClick={handleExpandClick}
            sx={{
              paddingLeft: "14px",
              paddingBottom: "8px",
              cursor: "pointer",
            }}
          >
            <Stack direction={"row"} alignItems={"center"} spacing={0.5}>
              <Typography variant={"body2"} color={"text.secondary"}>
                {group.submissions.length} {"submissions"} {" • "}
                {getDateRange()}
              </Typography>
              <IconButton size={"small"} sx={{ p: 0.5 }}>
                {expanded ? <CollapseIcon /> : <ExpandIcon />}
              </IconButton>
            </Stack>
          </Box>
        }

        <Collapse in={expanded} timeout={"auto"} unmountOnExit>
          <Stack spacing={0} sx={{ padding: "0px 14px 0px" }}>
            {group.submissions
              .filter(
                (submission) =>
                  submission.submissionId !== latestSubmission.submissionId
              )
              .map((submission) => {
                return (
                  <SearchCard
                    key={submission.submissionId}
                    submission={submission}
                    searchConfig={searchConfig}
                    configLoading={configLoading}
                    filterClicked={filterClicked}
                    sx={{
                      marginBottom: 2,
                      "& .MuiCard-root": {
                        marginBottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                  />
                );
              })}
          </Stack>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default GroupedSearchCard;
